import { compose, withHandlers, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';

import AddressItem from 'components/form/AddressSelector/Items/Address/component';

const enhance = compose(
  withTranslation('StopAddress'),
  withHandlers({
    handleClick:
      ({ value, onClick }) =>
      () => {
        if (onClick) {
          onClick({ value });
        }
      },
  }),
  withProps(({ value }) => ({
    address: value,
  }))
);

export default enhance(AddressItem);
